<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label>Add Note</label>
                    <textarea class="form-control" rows="6" placeholder="Required" v-model="noteText"></textarea>
                </div>
                <div class="d-flex">
                    <button class="btn btn-success ml-auto" @click="saveNote" :disabled="noteText === '' || noteSaving">
                        <template v-if="!noteSaving">Save note</template>
                        <template v-if="noteSaving"><animated-loading class="mr-2" size="xs"></animated-loading> Saving note</template>
                    </button>
                </div>
            </div>
        </div>

        <!-- Footer -->
        <fixed-footer
                :class="{'active': noteSaved}"
                :nextLabel="`Next`"
                :nextRoute="`revisit.update-address`"
                :prevRoute="`revisit.repair-parts`">
        </fixed-footer>
    </div>
</template>

<script>
    import {mapActions} from "vuex";

    export default {
        name: "RevisitNote",

        data() {
            return {
                noteText: null,
                noteSaved: false,
                noteSaving: false
            }
        },

        mounted() {
            this.updateRevisitReason();
            this.loadExistingNotes();
        },

        methods: {
            ...mapActions([
                "displayToast"
            ]),

            loadExistingNotes() {
                this.$http.get(`/api/v4/warranty/booking/${localStorage.revisitBookingId}`)
                    .then(res => {
                        this.noteText = res.data.data.note;

                        if (this.noteText) {
                            this.noteSaved = true;
                        }
                    })
            },

            /** Save note */
            saveNote() {
                if (!this.noteText) {
                    this.displayToast({text: 'You need to add text to the note', type: 'warning'});
                    return;
                }

                this.noteSaving = true;
                this.$http.post(`/api/v4/warranty/booking/${localStorage.revisitBookingId}/note`,
                    {
                        note: this.noteText
                    })
                    .then(() => {
                        this.displayToast({text: 'Note saved', type: 'success'});
                        this.noteSaving = false;
                        this.noteSaved = true;
                    })
            },

            /** Update revisit reason */
            updateRevisitReason() {
                this.$http.post(`/api/v4/warranty/booking/${localStorage.revisitBookingId}/type/118`);
            }
        }
    }
</script>

<style scoped>

</style>
